import { render, staticRenderFns } from "./EditAuthorization.vue?vue&type=template&id=34408e06&scoped=true&"
import script from "./EditAuthorization.vue?vue&type=script&lang=js&"
export * from "./EditAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./EditAuthorization.vue?vue&type=style&index=0&id=34408e06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34408e06",
  null
  
)

export default component.exports